import {
  postAdminShiftAssignment, postAdminShiftAssignmentPreview, postDirectBooking, postDirectBookingPreview,
  searchLocumsAsAdmin, searchLocumsForDirectBooking, searchStoresAsAdmin,
} from '../Api';

/**
 * The booking page is shared by the admin tool and the direct booking tool for Luxottica businesses. The page is
 * identical. The only differences are which locums and stores can be picked, and the server enforces them:
 * admin: any locum and any store. business: locums who have worked at their stores, and their own stores only.
 */
export const ADMIN_MODE = {
  isBusiness: false,
  searchLocums: searchLocumsAsAdmin,
  searchStores: searchStoresAsAdmin,
  previewBooking: postAdminShiftAssignmentPreview,
  confirmBooking: postAdminShiftAssignment,
};

export const BUSINESS_MODE = {
  isBusiness: true,
  searchLocums: searchLocumsForDirectBooking,
  searchStores: null,
  previewBooking: postDirectBookingPreview,
  confirmBooking: postDirectBooking,
};
